import toastLib, { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <div aria-live="polite" aria-atomic="false">
    <HotToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--surface-elevated)',
          color: 'var(--body)',
          border: '1px solid var(--border)',
          borderRadius: '12px',
          boxShadow:
            '0 12px 24px -4px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05)',
          padding: '12px 16px',
          fontSize: '14px',
          maxWidth: '420px',
        },
        success: {
          iconTheme: {
            primary: '#10B981',
            secondary: 'var(--surface)',
          },
        },
        error: {
          iconTheme: {
            primary: '#F43F5E',
            secondary: 'var(--surface)',
          },
        },
      }}
    />
    </div>
  );
}

export const toast = {
  success(message: string) {
    return toastLib.success(message);
  },

  error(message: string) {
    return toastLib.error(message);
  },

  info(message: string) {
    return toastLib(message, {
      icon: '💬',
      style: {
        borderLeft: '3px solid var(--primary)',
      },
    });
  },

  loading(message: string) {
    return toastLib.loading(message);
  },
};
